import React, { useState } from "react";
import { Link } from "react-router-dom";
import icons from "../constants/icons.ts";
import images from "../constants/images.ts";
import { navItems } from "../constants/data.ts";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <nav className="container mx-auto px-outer py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex shrink-0 items-center gap-3">
          <img
            src={images.brand.logoEncoded}
            alt="Westlisoft Logo"
            className="block h-11 w-11 rounded-full object-contain"
          />
          <span className="text-2xl font-bold leading-none text-secondary">
            Westlisoft
          </span>
        </Link>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex gap-8 items-center">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className="text-secondary font-rubik font-medium hover:text-primary transition-colors duration-300"
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li>
            <a
              href="https://wa.me/918977937065"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary flex items-center gap-2"
            >
              <i className={icons.social.whatsapp}></i>
              WhatsApp
            </a>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-secondary text-2xl"
        >
          <i className={isMenuOpen ? icons.actions.close : icons.actions.bars}></i>
        </button>
      </nav>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-background px-outer py-4 border-t border-gray-200">
          <ul className="space-y-3">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="text-secondary font-rubik block hover:text-primary"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href="https://wa.me/918977937065"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary flex items-center gap-2 justify-center"
              >
                <i className={icons.social.whatsapp}></i>
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
